import BannerWidgetComponent from "./BannerWidgetComponent";

const BannerWidget = ({ layout }) => (
  <BannerWidgetComponent layout={layout} />
);

export default BannerWidget;
